import {
  FormControl,
  FormLabel,
  TextField,
  FormControlLabel,
  Radio,
  RadioGroup,
  FormHelperText,
} from "@mui/material";
import React, { useEffect } from "react";
import { Controller, useFormContext } from "react-hook-form"; // Import useFormContext

export default function Form3() {
  const {
    watch,
    control,
    register,
    clearErrors,
    setValue,
    formState: { errors },
  } = useFormContext();

  const hasEmployees = watch("employees");
  useEffect(() => {
    window.scrollTo(0, 0);
    clearErrors([]);
  }, []);
  useEffect(() => {
    setValue("highPaid", "");
    setValue("monthlyHighPaid", "");
    setValue("midPaid", "");
    setValue("monthlyMidPaid", "");

    setValue("lowPaid", "");
    setValue("monthlyLowPaid", "");
    setValue("highPaidsecd", "");
  }, [hasEmployees]);

  return (
    <form className="d-flex flex-column py-3 gap-3">
      <FormControl className="d-flex flex-column bg-white rounded-4 p-3 ">
        <FormLabel>Do you currently have employees?</FormLabel>
        <Controller
          name="employees"
          control={control}
          render={({ field }) => (
            <RadioGroup {...field}>
              <FormControlLabel value={"yes"} control={<Radio />} label="Yes" />
              <FormControlLabel value={"no"} control={<Radio />} label="No" />
            </RadioGroup>
          )}
        />
        {errors.employees && (
          <FormHelperText error>{errors.employees.message}</FormHelperText>
        )}
      </FormControl>

      {hasEmployees === "yes" && (
        <>
          <FormControl className="d-flex flex-column bg-white rounded-4 p-3 ">
            <FormLabel>
              If we were to break your company out into 3 areas: High, Mid, and
              Low paid Field employees. What would you classify as an hourly
              rate for HIGH paid Field employees?
            </FormLabel>
            <TextField
              sx={{ maxWidth: 360 }}
              label="Your Answer"
              variant="standard"
              {...register("highPaid")}
              error={!!errors.highPaid}
              helperText={errors.highPaid ? errors.highPaid.message : ""}
            />
          </FormControl>

          <FormControl className="d-flex flex-column bg-white rounded-4 p-3 ">
            <FormLabel>
              How many high paid Field employees do you have?
            </FormLabel>
            <TextField
              sx={{ maxWidth: 360 }}
              label="Your Answer"
              variant="standard"
              {...register("monthlyHighPaid")}
              error={!!errors.monthlyHighPaid}
              helperText={
                errors.monthlyHighPaid ? errors.monthlyHighPaid.message : ""
              }
            />
          </FormControl>

          <FormControl className="d-flex flex-column bg-white rounded-4 p-3 ">
            <FormLabel>
              If we were to break your company out into 3 areas: High, Mid, and
              Low paid Field employees. What would you classify as an hourly
              rate for MID paid Field employees?
            </FormLabel>
            <TextField
              sx={{ maxWidth: 360 }}
              label="Your Answer"
              variant="standard"
              {...register("midPaid")}
              error={!!errors.midPaid}
              helperText={errors.midPaid ? errors.midPaid.message : ""}
            />
          </FormControl>

          <FormControl className="d-flex flex-column bg-white rounded-4 p-3 ">
            <FormLabel>
              How many MID paid Field employees do you have?
            </FormLabel>
            <TextField
              sx={{ maxWidth: 360 }}
              label="Your Answer"
              variant="standard"
              {...register("monthlyMidPaid")}
              error={!!errors.monthlyMidPaid}
              helperText={
                errors.monthlyMidPaid ? errors.monthlyMidPaid.message : ""
              }
            />
          </FormControl>
          <FormControl className="d-flex flex-column bg-white rounded-4 p-3 ">
            <FormLabel>
              If we were to break your company out into 3 areas: High, Mid, and
              Low paid Field employees. What would you classify as an hourly
              rate for LOW paid Field employees?
            </FormLabel>
            <TextField
              sx={{ maxWidth: 360 }}
              label="Your Answer"
              variant="standard"
              {...register("lowPaid", { required: true })}
              error={!!errors.lowPaid}
              helperText={errors.lowPaid ? errors.lowPaid.message : ""}
            />{" "}
          </FormControl>
          <FormControl className="d-flex flex-column bg-white rounded-4 p-3 ">
            <FormLabel>
              How many LOW paid Field employees do you have?
            </FormLabel>
            <TextField
              sx={{ maxWidth: 360 }}
              label="Your Answer"
              variant="standard"
              {...register("monthlyLowPaid", { required: true })}
              error={!!errors.monthlyLowPaid}
              helperText={
                errors.monthlyLowPaid ? errors.monthlyLowPaid.message : ""
              }
            />{" "}
          </FormControl>
        </>
      )}
      {hasEmployees === "no" && (
        <>
          <FormControl className="d-flex flex-column bg-white rounded-4 p-3 ">
            <FormLabel>
              If you do not have employees, what do you want to make an hour to
              charge customers? Keep in mind if you added money to Question 4
              (owner's cash), put a number per hour you wish to charge. Please
              only give what you want to make, not what you want to profit from
              the customer; our program will auto-figure that out for you.
            </FormLabel>
            <TextField
              sx={{ maxWidth: 360 }}
              label="Your Answer"
              variant="standard"
              {...register("highPaidsecd", { required: true })}
              error={!!errors.highPaidsecd}
              helperText={
                errors.highPaidsecd ? errors.highPaidsecd.message : ""
              }
            />
          </FormControl>
        </>
      )}
    </form>
  );
}
